import { instance } from './index';

// Get notifications
function fetchNotice() {
  return instance.get('/notifications');
}

export default { fetchNotice };
